import { ROLE } from "@/utils/constant";
import { SidebarMenuConfig } from "./nav-config";

export const navRebuildConfig: SidebarMenuConfig[] = [
  {
    href: "/master-profile",
    label: "Master Profile",
    child: [
      {
        href: "/master-profile",
        label: "List Profile",
        allowedRoles: [ROLE.ADMINISTRATOR],
      },
    ],
    allowedRoles: [ROLE.ADMINISTRATOR],
  },
];
